import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { useNavigate } from "react-router-dom";
import { getAllExpenses } from "../../store/AsyncMethods/ExpenseMethods";

export default function ExpensesTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Ensure `allExpenses` is always an array
  let allExpenses = useSelector((state) => state.expenseReducer.allExpenses);
  const { user } = useSelector((state) => state.AuthReducer);

  allExpenses = Array.isArray(allExpenses) ? allExpenses : [];

  const updatedAllExpenses = allExpenses.map((item, index) => ({
    number: index + 1,
    ...item
  }))

  console.log("allExpenses ---->", allExpenses);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  useEffect(() => {
    if (user) {
      dispatch(getAllExpenses());
    }
  }, [dispatch, user]);

  const onGlobalFilterChange = (event) => {
    const value = event.target.value;
    setFilters((prevFilters) => ({
      ...prevFilters,
      global: { ...prevFilters.global, value },
    }));
  };

  const header = (
    <div className="flex justify-between">
      <span className="p-input-icon-left flex w-10/12 sm:w-8/12 md:w-6/12 lg:w-4/12 xl:w-3/12">
        <InputText
          className="w-full p-primary-input"
          type="search"
          value={filters.global?.value || ""}
          onChange={onGlobalFilterChange}
          placeholder="Search"
        />
      </span>
    </div>
  );

  return (
    <div>
      <div className="card shadow-sm">
        <DataTable
          value={updatedAllExpenses} // ✅ Always an array
          tableStyle={{ minWidth: "50rem" }}
          stripedRows
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 25, 50]}
          header={header}
          filters={filters}
          onFilter={(e) => setFilters(e.filters)}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
        >
          <Column field="number" sortable header="No." />
          <Column field="created_date" sortable header="Expense Date" />
          <Column field="description" sortable header="Expense Description" />
          <Column field="amount" sortable header="Amount" />
        </DataTable>
      </div>
    </div>
  );
}
